var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.photos),function(photo){return _c('div',{key:photo.url,staticClass:"photos"},[_c('Photo',{attrs:{"url":photo.url}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }